import { members_global } from "../mock-data/data-members";

async function getDataMembersGlobal() {
  return members_global;
}

export default {
  getDataMembersGlobal
};
